import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DateTime from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useDetalhamento from "../hooks/useDetalhamento";
import FormDemonstrativos from "../FormDemonstrativos";
import useMontarLogica from "../hooks/useMontarLogica";
import constants from "../../../Constants";

const columns = [
  {
    name: "Referência",
    selector: (row) => row.txReferencia,
    minWidth: "7%",
    center: true,
  },
  {
    name: "Data de Vencimento",
    selector: (row) => row.dtVencimento,
    minWidth: "12%",
    cell: (row) => <DateTime value={row.dtVencimento} stringFormat="dd/MM/yyyy" />,
    center: true,
  },

  {
    name: "CMV",
    selector: (row) =>
      row.vlCMV ? row.vlCMV.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : row.vlCMF,
    minWidth: "7%",
    center: true,
  },

  {
    name: "Vendas Arbitradas",
    selector: (row) =>
      row.vlVendasArbitradas
        ? row.vlVendasArbitradas.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : row.vlVendasArbitradas,
    minWidth: "12%",
    center: true,
  },

  {
    name: "Vendas Declaradas",
    selector: (row) =>
      row.vlVendasDeclaradas
        ? row.vlVendasDeclaradas.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : row.vlVendasDeclaradas,
    minWidth: "10%",
    center: true,
  },
  {
    name: "Omissão de Saídas",
    selector: (row) =>
      row.vlOmissaoSaidas
        ? row.vlOmissaoSaidas.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : row.vlOmissaoSaidas,
    minWidth: "10%",
    center: true,
  },
  {
    name: "Base de Cálculo",
    selector: (row) =>
      row.vlBaseCalculo
        ? row.vlBaseCalculo.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : row.vlBaseCalculo,
    minWidth: "10%",
    center: true,
  },
  {
    name: "Crédito/Deduções",
    selector: (row) =>
      row.vlCredito ? row.vlCredito.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : row.vlCredito,
    minWidth: "12%",
    center: true,
  },
  {
    name: "ICMS",
    selector: (row) => row.vlIcms.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    minWidth: "7%",
    center: true,
  },
  {
    name: "Multa",
    selector: (row) => row.vlMultaOcorrenciaAtual.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
    minWidth: "7%",
    center: true,
  },
];

const conditionalRowStyles = [
  {
    when: (row) => row.dsItem === "Total",
    style: { backgroundColor: "#d3d3d3", cursor: "not-allowed" },
  },
];

const ListagemV = ({ history, sqItemOcorrencia, sqAcaoFiscal }) => {
  const [reload, setReload] = useState(false); // Estado para forçar a atualização
  const { dataWithTotal, totalRows, isLoading } = useDetalhamento({
    sqAcaoFiscal,
    sqItemOcorrencia,
    reload,
  });

  const [dados, setDados] = useState({});

  const { montarLogica, mostrarLista, setMostrarLista } = useMontarLogica();

  useEffect(() => {
    if (mostrarLista) {
      montarLogica(1);
    }
  }, [montarLogica, mostrarLista, reload]);

  const voltarListagem = () => {
    setMostrarLista(true);
    setReload((prev) => prev + 1);
  };

  return mostrarLista ? (
    <DataTable
      noHeader
      keyField="sqItemOcorrencia"
      columns={columns}
      data={dataWithTotal}
      progressPending={isLoading}
      noDataComponent="Nenhum registro para exibir"
      progressComponent={<TextSpinner />}
      paginationTotalRows={totalRows}
      pointerOnHover
      pagination
      paginationComponentOptions={constants.paginationComponentOptions}
      paginationRowsPerPageOptions={[10, 20, 50, 100, 1000]}
      onRowClicked={(row) => {
        if (row.dsItem !== "Total") {
          setDados(row);
          montarLogica(4);
        }
      }}
      conditionalRowStyles={conditionalRowStyles}
      paginationPerPage={10}
      selectableRowDisabled={(row) => row.dsItem === "Total"}
      selectableRowsVisibleOnly={(row) => !(row.dsItem === "Total")}
    />
  ) : (
    <FormDemonstrativos
      tipoDetalhamento={dados.tipoDetalhamento}
      sqItemOcorrencia={dados.sqItemOcorrencia}
      sqAcaoFiscal={dados.sqAcaoFiscal}
      dadosOcorrencia={dados}
      history={history}
      voltarListagem={() => voltarListagem()}
    />
  );
};

export default ListagemV;
